import React from "react";
import { Box, Typography, Grid, Avatar } from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import green1 from "../../Assests/green1.png"
import green2 from "../../Assests/green2.png"
import green3 from "../../Assests/green3.png"
import green4 from "../../Assests/green4.png"

const steps = [
  {
    icon: green1,
    title: "Choose Your Payment Method",
    description:
      "Select your preferred payment option: card, wallet, or bank transfer all in one secure place.",
  },
  {
    icon: green2,
    title: "Confirm & Pay",
    description:
      "Review your order details, then tap Pay Now. Your payment is securely processed within seconds.",
  },
  {
    icon: green3,
    title: "Transaction in Progress",
    description:
      "We instantly connect with your bank or payment provider to verify your transaction.",
  },
  {
    icon: green4,
    title: "Payment Complete",
    description:
      "You’ll receive instant confirmation and a digital receipt.",
  },
];

const PaymentJourney = () => {
  return (
    <Box sx={{ 
      textAlign: "center", 
      py: { xs: 4, sm: 6, md: 8 }, 
      px: { xs: 2, sm: 3, md: 4 },
      backgroundColor: "rgba(16, 185, 129, 0.1)" 
    }}>
      <Typography variant="body2" color="primary" fontWeight={500}>
        How to works?
      </Typography>

      <Typography 
        variant="h5" 
        fontWeight="bold" 
        mt={1}
        sx={{
          fontWeight: 500,
          fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
          px: { xs: 2, sm: 0 }
        }}
      >
        Your Payment Journey with Zutopay
      </Typography>

      <Typography 
        variant="body2" 
        color="text.secondary" 
        mt={1}
        sx={{
          maxWidth: '800px',
          mx: 'auto',
          px: { xs: 1, sm: 2 },
          fontSize: { xs: '0.9rem', sm: '1rem' },
          '& br': {
            display: { xs: 'none', sm: 'inline' }
          }
        }}
      >
        Experience a fast, reliable, and secure payment process. Every transaction is protected, verified, and updated in real time.
      </Typography>

      <Box sx={{ position: "relative", mt: { xs: 6, sm: 8 } }}>
        {/* Dashed Line - Only show on desktop */}
        <Box
          sx={{
            display: { xs: 'none', sm: 'block' },
            position: "absolute",
            top: { xs: '40px', sm: '30px' },
            left: { sm: '15%', md: '10%' },
            right: { sm: '15%', md: '10%' },
            borderTop: "2px dashed #6ac4a3",
            zIndex: 1,
          }}
        />

        {/* Steps */}
        <Grid container spacing={{ xs: 4, sm: 3 }} justifyContent="center">
          {steps.map((step, index) => (
            <Grid
              item
             size={{ xs: 12, sm: 6, md: 3 }}
              key={index}
              sx={{ 
                position: "relative", 
                zIndex: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                px: { xs: 2, sm: 1 }
              }}
            >
              <Box
                component="img"
                src={step.icon}
                alt={step.title}
                sx={{
                  width: { xs: 56, sm: 64 },
                  height: { xs: 56, sm: 64 },
                  mb: 2,
                }}
              />
              <Typography
                variant="subtitle1"
                fontWeight={600}
                gutterBottom
                color="#00796b"
                sx={{
                  fontSize: { xs: '1rem', sm: '1.1rem' },
                  mb: { xs: 1, sm: 2 }
                }}
              >
                {step.title}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ 
                  maxWidth: 280,
                  mx: 'auto',
                  fontSize: { xs: '0.875rem', sm: '0.9375rem' },
                  lineHeight: 1.5
                }}
              >
                {step.description}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default PaymentJourney;